module.exports = __webpack_public_path__ + "img/imagem-sobre-complexo-01.7707cbd1.png";